<!-- 点名方式 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="courseSignType" type="courseSignType" clearable/>
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-点名方式',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '点名方式：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const courseSignType = useQuery('courseSignType', props.value);

    return {
      courseSignType,
    };
  },
};
</script>
